import { Prisma, PrismaClient } from "../generated";

// Extend to rename and allow NestJS DI to differentiate between this
// and other Prisma clients (e.g. factory, old database)
export class PrimaryModelsClient extends PrismaClient {

  public async healthcheck() {
    await this.$queryRaw`SELECT 1;`;
  }

  /** If a transaction is provided, use it to call the provided function.
   * Otherwise, start a new one and use that to call the provided function.
   * This is useful when you want to make it possible but not required for a
   * service method to continue an existing transaction instead of starting a
   * new one.
   * This is useful for services that are called by other services. */
  public async startOrContinueTransaction<T>(
    inTx: Prisma.TransactionClient | undefined,
    fn: (tx: Prisma.TransactionClient) => Promise<T>,
  ): Promise<T> {
    if (inTx) {
      return fn(inTx);
    }
    return this.$transaction(fn);
  }

}
